export default "__VITE_ASSET__CD747K5S__"